export default async function ({ store, app, redirect, route, $config }) {
  // Only run on client side - skip server-side execution
  if (process.server) {
    return
  }

  // Client-side only from here
  
  // Skip auth check for callback and login pages.
  if (route.path === '/auth/callback' || route.path === '/login') {
    return
  }

  // Check if $auth is available
  if (!app.$auth) {
    return
  }

  // Check if we have cached auth in store (from localStorage)
  const cachedAuth = store.state.auth
  let isAuthenticated = false
  
  if (cachedAuth.isAuthenticated && cachedAuth.user) {
    isAuthenticated = true
  } else {
    // Only call API if no cached data
    isAuthenticated = await app.$auth.checkAuthStatus()
  }

  if (!isAuthenticated) {
    // Redirect to OAuth2 login endpoint
    // const gatewayUrl = $config.gatewayUrl || process.env.GATEWAY_URL || 'http://localhost:6061'  //old url
    const gatewayUrl = $config.gatewayUrl

    const loginUrl = `${gatewayUrl}/oauth2/authorization/gateway-client`
    
    // Client-side redirect
    window.location.href = loginUrl
    console.log("Skipping auth redirect (no backend yet)")

  }
}

